import React from 'react';
import { Clock, Target, Wallet, FileCheck } from 'lucide-react';

interface Props {
  application: Record<string, any>;
}

export const DeadlineTrackerWidget: React.FC<Props> = ({ application: app }) => {
  const isDevGrant = app.service_type === 'dotacje_rozwojowe';
  const totalCost = Number(app.dev_grant_total_cost || app.requested_amount || 0);
  const ownContribution = Number(app.dev_grant_own_contribution || 0);
  const grantAmount = Number(app.dev_grant_requested_amount || app.requested_amount || 0);
  const progress = totalCost > 0 ? Math.min(100, Math.round((ownContribution / totalCost) * 100)) : 0;

  const status = app.dev_grant_status || app.grant_fpn_status || 'nowe';
  const program = app.dev_grant_grant_program || '';

  return (
    <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg shadow p-5 border border-amber-200">
      <h3 className="font-bold text-sm flex items-center gap-2 mb-3 text-amber-800">
        <Clock size={16} />
        {isDevGrant ? 'Tracker dotacji' : 'Tracker grantu'}
      </h3>
      {program && (
        <div className="mb-3 text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded inline-block font-medium">
          {program}
        </div>
      )}
      <div className="space-y-3">
        {/* Budget bar */}
        {totalCost > 0 && (
          <div>
            <div className="flex justify-between text-xs text-gray-600 mb-1">
              <span className="flex items-center gap-1"><Wallet size={12} /> Budżet projektu</span>
              <span>{totalCost.toLocaleString('pl-PL')} zł</span>
            </div>
            <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-amber-400 to-yellow-500 rounded-full transition-all" style={{ width: `${progress}%` }} />
            </div>
            <div className="flex justify-between text-[10px] text-gray-500 mt-0.5">
              <span>Wkład własny: {ownContribution.toLocaleString('pl-PL')} zł ({progress}%)</span>
              <span>Dotacja: {grantAmount.toLocaleString('pl-PL')} zł</span>
            </div>
          </div>
        )}
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="flex items-center gap-2">
            <Target size={14} className="text-amber-500 shrink-0" />
            <span>Status: <strong className="capitalize">{status.replace(/_/g, ' ')}</strong></span>
          </div>
          {app.dev_grant_project_title && (
            <div className="flex items-center gap-2 col-span-2">
              <FileCheck size={14} className="text-amber-500 shrink-0" />
              <span className="truncate">{app.dev_grant_project_title}</span>
            </div>
          )}
          {app.dev_grant_wojewodztwo && (
            <div className="text-xs text-gray-500 col-span-2">
              Woj.: {app.dev_grant_wojewodztwo}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
